import PropTypes from "prop-types";

import Tabs from "react-bootstrap/Tabs";

import Tab from "react-bootstrap/Tab";

import Container from "react-bootstrap/Container";

const TabsCustom = ({
  defaultActiveKey,
  classNameOfTabContainer,
  classNameOfTabs,
  tabs,
  selectedTab,
  setSelectedTab,
}) => {
  return (
    <Container className={classNameOfTabContainer} expand="lg">
      <Tabs
        activeKey={selectedTab ? selectedTab : undefined}
        onSelect={selectedTab ? (k) => setSelectedTab(k) : undefined}
        defaultActiveKey={defaultActiveKey}
        variant={classNameOfTabs}
      >
        {tabs.map((tab, index) => {
          return (
            <Tab
              key={tab.title + index}
              disabled={tab.disabled}
              eventKey={tab.eventKey}
              tabClassName={tab.tabClassName}
              title={
                tab.title !== "Community" && tab.title
                // tab.title === "Community" ? (
                //   <>
                //     {tab.title}
                //     <DesignedLabel
                //       classNameLabel="coming-soon-label fs-10"
                //       label="COMING SOON"
                //     />
                //   </>
                // ) : (
                //   tab.title
                // )
              }
            >
              {tab.component}
            </Tab>
          );
        })}
      </Tabs>
    </Container>
  );
};

TabsCustom.propTypes = {
  classNameOfTabContainer: PropTypes.string,
  classNameOfTabs: PropTypes.string,
  defaultActiveKey: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      eventKey: PropTypes.string,
      tabClassName: PropTypes.string,
      title: PropTypes.string,
      component: PropTypes.node,
    })
  ),
  selectedTab: PropTypes.string,
  setSelectedTab: PropTypes.func,
};

TabsCustom.defaultProps = {
  classNameOfTabContainer: "",
  classNameOfTabs: "",
  defaultActiveKey: "",
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: false,
      eventKey: "",
      tabClassName: "",
      title: "",
      component: <> </>,
    })
  ),
  selectedTab: "",
  setSelectedTab: () => {},
};

export default TabsCustom;
